import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import { useSelector } from 'react-redux';
import { useResponsive } from '../../hooks/use-responsive';
import { bgBlur } from '../../theme/css';
import Iconify from '../../components/iconify';
import Searchbar from './common/searchbar';
import { NAV, HEADER } from './config-layout';
import AccountPopover from './common/account-popover';
import NotificationsPopover from './common/notifications-popover';
import SiteOpenAlert from '../../components/site-open-alert/site-open-alert';

// ----------------------------------------------------------------------

export default function Header({ onOpenNav }) {
  const theme = useTheme();

  const lgUp = useResponsive('up', 'lg');
  const sites = useSelector((state) => state.app.sites);
  const site = useSelector((state) => state.app.site);
  const siteId = useSelector((state) => state.app.siteId);

  const renderContent = (
    <>
      {!lgUp && (
        <IconButton onClick={onOpenNav} sx={{ mr: 1 }}>
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>
      )}

      {/* <Searchbar /> */}

      <Box
        id="header-page-title"
        sx={{
          display: 'flex',
          alignItems: 'center',
          minWidth: 0,
          mr: 2,
        }}
      />

      <Box sx={{ flexGrow: 1 }} />

      <Stack direction="row" alignItems="center" spacing={1}>
        <SiteOpenAlert
          sites={sites}
          selectedSiteId={site !== 'All' ? siteId : null}
        />
        {/* <NotificationsPopover /> */}
        <Box
          id="header-page-actions"
          sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
        />
        <AccountPopover />
      </Stack>
    </>
  );

  return (
    <AppBar
      sx={{
        boxShadow: 'none',
        height: HEADER.H_MOBILE,
        zIndex: theme.zIndex.appBar + 1,
        ...bgBlur({
          color: theme.palette.background.default,
        }),
        transition: theme.transitions.create(['height'], {
          duration: theme.transitions.duration.shorter,
        }),
        ...(lgUp && {
          width: `calc(100% - ${NAV.WIDTH}px)`,
          height: HEADER.H_DESKTOP,
        }),
      }}
    >
      <Toolbar
        sx={{
          height: 1,
          px: { lg: 5 },
        }}
      >
        {renderContent}
      </Toolbar>
    </AppBar>
  );
}

Header.propTypes = {
  onOpenNav: PropTypes.func,
};
